import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { index: { type: Number, default: 0 } }

  connect() {
    if (this.indexValue > 0) {
      this.element.setActiveTab(this.indexValue)
    }
  }
}
